import { Grid } from '@farewill/ui'

import InputFloating from 'components/form/input-floating'
import { ADVISOR_SCHEMA } from 'lib/probate/estate-questionnaire-schema'

import RecordsSection, { RecordsSubSectionProps } from './records-section'

const Advisors = ({
  collection,
  sectionActive,
  saveProbateEstateField,
}: RecordsSubSectionProps) => (
  <RecordsSection
    heading="2.7 Accountant or professional advisors"
    cardType="Advisor"
    addLabel="Add advisor"
    toggleName="advisorsSectionActive"
    sectionActive={sectionActive}
    saveProbateEstateField={saveProbateEstateField}
    collection={collection}
    schema={ADVISOR_SCHEMA}
    renderFields={({ handleSave, pairedFieldSpan }) => (
      <>
        <Grid.Item span={pairedFieldSpan}>
          <InputFloating
            name="fullName"
            label="Full name"
            handleSave={handleSave}
          />
        </Grid.Item>
        <Grid.Item span={pairedFieldSpan}>
          <InputFloating
            name="accountReference"
            label="Account reference"
            handleSave={handleSave}
          />
        </Grid.Item>
        <Grid.Item span={pairedFieldSpan}>
          <InputFloating name="email" label="Email" handleSave={handleSave} />
        </Grid.Item>
        <Grid.Item span={pairedFieldSpan}>
          <InputFloating
            name="phoneNumber"
            label="Phone number"
            handleSave={handleSave}
          />
        </Grid.Item>
      </>
    )}
  />
)

export default Advisors
